import { render, staticRenderFns } from "./columnar.vue?vue&type=template&id=6089d52c&"
import script from "./columnar.vue?vue&type=script&lang=js&"
export * from "./columnar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports